import React, {useEffect, useReducer, useState} from 'react';
import PlaceForm from "../Utilities/PlaceForm";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import {Header, Icon, SegmentGroup} from "semantic-ui-react";
import Segment from "semantic-ui-react/dist/commonjs/elements/Segment";
import axios from "axios";
import {toast} from "react-toastify";

const reducer = (state, action)=> {
    switch (action.type) {
        case 'countries':
            return {...state, countries: action.payload};
        case 'entities':
            return {...state, entities: action.payload };
        case 'cantons':
            return {...state, cantons: action.payload };
        case 'municipalities':
            return {...state, municipalities: action.payload };
        case 'placeOfResidence':
            return {...state, placeOfResidence: action.payload};
        default:
            return state;
    }
};
const StudentPlaceOfResidenceForm = ({toggleEditForm, add, edit, getStudent, student, getTeacher, teacher, municipalities}) => {
    const [countryErr, setCountryErr] = useState(false);
    const [placeErr, setPlaceErr] = useState(false);
    const [addressErr, setAddressErr] = useState(false);
    const [zipErr, setZipErr] = useState(false);

    const [state, dispatch] = useReducer(reducer,{

        firstName: (edit && student) ? student.student.person.firstName : (edit && teacher) ? teacher.person.firstName : '',
        lastName: (edit && student) ? student.student.person.lastName : (edit && teacher) ? teacher.person.lastName: '',
        maidenName: (edit && student) ? student.student.person.maidenName : (edit && teacher) ? teacher.person.maidenName : '',
        gender: (edit && student) ? student.student.person.gender.id : (edit && teacher) ? teacher.person.gender.id : null,
        fatherFirstName: (edit && student) ? student.student.fatherFirstName :'',
        fatherLastName: (edit && student) ? student.student.fatherLastName : '',
        motherFirstName: (edit && student) ? student.student.motherFirstName : '',
        motherLastName: (edit && student) ? student.student.motherLastName : '',
        jmbg: (edit && student) ? student.student.person.jmbg : (edit && teacher) ? teacher.person.jmbg : '',
        oid: (edit && student) ? student.student.person.oid : (edit && teacher) ? teacher.person.oid : '',
        dateOfBirth: (edit && student) ? student.student.person.dateOfBirth : (edit && teacher) ? teacher.person.dateOfBirth : new Date(),
        placeOfBirth: (edit && student) ? student.student.person.placeOfBirth : (edit && teacher) ? teacher.person.placeOfBirth : '',

        //teacher
        numberOfHoursInOriginPlaceOfEmployment: (edit && teacher) ? teacher.numberOfHoursInOriginPlaceOfEmployment : '',
        originPlaceOfEmployment : (edit && teacher) ? teacher.numberOfHoursInOriginPlaceOfEmployment : '',

        // student
        fileNumber: (edit && student) ? student.fileNumber : '',
        studyProgram: (edit && student) ? student.studyProgram : '',
        language: (edit && student) ? student.language : [],
        occupationType: (edit && student) ? student.student.occupationType : null,
        fileDate: (edit && student) ? student.fileDate : new Date(),
        startDate: (edit && student) ? student.startDate : new Date(),

        countries:[],
        entities: [],
        cantons: [],
        municipalities: [],

        country: (edit && student) ? student.student.person.residence.place.country : (edit && teacher) ? teacher.person.residence.place.country : '',
        entity: edit && student &&  !!student.student.person.residence.place.municipality && !!student.student.person.residence.place.municipality.entity ? student.student.person.residence.place.municipality.entity : edit && teacher &&  !!teacher.person.residence.place.municipality && !!teacher.person.residence.place.municipality.entity ? teacher.person.residence.place.municipality.entity : '',
        canton: (edit && student) ?  !!student.student.person.residence.place.municipality && !!student.student.person.residence.place.municipality.canton && student.student.person.residence.place.municipality.canton : (edit && teacher) ?  !!teacher.person.residence.place.municipality && !!teacher.person.residence.place.municipality.canton && teacher.person.residence.place.municipality.canton : '',
        municipality: edit && student && !!student.student.person.residence.place.municipality ?  student.student.person.residence.place.municipality : edit && teacher && !!teacher.person.residence.place.municipality ?  teacher.person.residence.place.municipality : '',
        place: (edit && student) ?  !!student.student.person.residence.place && student.student.person.residence.place.name : (edit && teacher) ?  !!teacher.person.residence.place && teacher.person.residence.place.name :'',
        address: (edit && student) ?  !!student.student.person.residence && student.student.person.residence.address : (edit && teacher) ?  !!teacher.person.residence && teacher.person.residence.address : '',
        zip: (edit && student) ?  !!student.student.person.residence && student.student.person.residence.zipCode : (edit && teacher) ?  !!teacher.person.residence && teacher.person.residence.zipCode : '',
        // disable properties
        enableEntity: (edit && student) ? !!student.student.person.residence.place.municipality && !!student.student.person.residence.place.municipality.entity: (edit && teacher) ? !!teacher.person.residence.place.municipality && !!teacher.person.residence.place.municipality.entity: false,
        enableCanton: (edit && student) ? !!student.student.person.residence.place.municipality && !!student.student.person.residence.place.municipality.canton : (edit && teacher) ? !!teacher.person.residence.place.municipality && !!teacher.person.residence.place.municipality.canton : false,
        enableMunicipality: (edit && student) ? student.student.person.residence.place.municipality !== null : (edit && teacher) ? teacher.person.residence.place.municipality !== null : false
    });

    function handlePlaceChange(placeName, obj) {
        dispatch({type: placeName, payload: obj});
    }

    function formValidation(){
        if (!state.placeOfResidence.country || !state.placeOfResidence.place || !state.placeOfResidence.address || !state.placeOfResidence.zip) {
            toast("Niste unijeli sve podatke!");
            if (!state.placeOfResidence.country) { setCountryErr(true); } else { setCountryErr(false); }
            if (!state.placeOfResidence.place) { setPlaceErr(true); } else { setPlaceErr(false); }
            if (!state.placeOfResidence.address) { setAddressErr(true); } else { setAddressErr(false); }
            if (!state.placeOfResidence.zip) { setZipErr(true); } else { setZipErr(false); }
            return false;
        }
        return true;
    }

    function editStudent(){
            let obj = {
                id: student.id,
                optLock: student.optLock,
                chosenLanguage: student.language,
                comment: student.comment,
                // created: new Date(),
                registryBook: student.registryBook,
                numberInRegistryBook: student.numberInRegistryBook,
                fileDate: student.fileDate,
                fileNumber: student.fileNumber,
                startDate: student.startDate,
                student: {
                    id: student.student.id,
                    created: new Date(),
                    fatherFirstName: student.student.fatherFirstName,
                    fatherLastName: student.student.fatherLastName,
                    motherFirstName: student.student.motherFirstName,
                    motherLastName: student.student.motherLastName,
                    occupationType: student.student.occupationType,
                    person: {
                        id: student.student.person.id,
                        created: new Date(),
                        dateOfBirth: student.student.person.dateOfBirth,
                        firstName: student.student.person.firstName,
                        lastName: student.student.person.lastName,
                        jmbg: student.student.person.jmbg,
                        oid: student.student.person.oid,
                        gender: {id: student.student.person.gender.id},
                        placeOfBirth: state.placeOfBirth,
                        residence: {
                            address: state.placeOfResidence.address,
                            zipCode: state.placeOfResidence.zip,
                            place: {
                                country: state.placeOfResidence.country,
                                name: state.placeOfResidence.place,
                                municipality: state.placeOfResidence.country.key === 'bih'?{
                                    id: state.placeOfResidence.municipality.id,
                                    canton: { id: state.placeOfResidence.canton.id },
                                    entity: { id: state.placeOfResidence.entity.id }
                                }: null
                            }

                        },

                    }
                },
                studyProgram: {
                    id: student.studyProgram.id
                }

            };
            axios.put('/student-study-program/edit', {...obj}).then(
                (res) => {
                    toggleEditForm();
                    toast('Uspješno ste izmijenili polaznika.');
                    getStudent();
                }).catch((err) => {
                console.log('err', err)
            });


    };

    function editTeacher(){
        let obj = {
            id: teacher.id,
            optLock: teacher.optLock,
            person: {
                // created: new Date(),
                id: teacher.person.id,
                optLock: teacher.person.optLock,
                dateOfBirth: teacher.person.dateOfBirth,
                firstName: teacher.person.firstName,
                lastName: teacher.person.lastName,
                maidenName: teacher.person.maidenName,
                jmbg: teacher.person.jmbg,
                oid: teacher.person.oid,
                gender: {id: teacher.person.gender.id},
                teacher: true,

                placeOfBirth: state.placeOfBirth,
                residence: {
                    id: teacher.person.residence.id,
                    optLock: teacher.person.residence.optLock,
                    address: state.placeOfResidence.address,
                    zipCode: state.placeOfResidence.zip,
                    place: {
                        id: teacher.person.residence.place.id,
                        optLock: teacher.person.residence.place.optLock,
                        country: state.placeOfResidence.country,
                        name: state.placeOfResidence.place,
                        municipality: state.placeOfResidence.country.key === 'bih'?{
                            id: state.placeOfResidence.municipality.id,
                            canton: { id: state.placeOfResidence.canton.id },
                            entity: { id: state.placeOfResidence.entity.id }
                        }: null
                    }

                },
            },
            numberOfHoursInOriginPlaceOfEmployment: state.numberOfHoursInOriginPlaceOfEmployment,
            // created: new Date(),
            originPlaceOfEmployment: state.originPlaceOfEmployment,

        };
        axios.put('/teacher/edit', {...obj}).then(
            (res) => {
                toggleEditForm();
                toast('Uspješno ste izmijenili nastavnika/icu.');
                getTeacher();
            }).catch((err) => {
            toast('Došlo je do greške!');
            console.log('err', err)
        });


    };

    useEffect(() => {
        axios.get('/country/all',).then(
            (res)=>{
                let countriesOptions = res.data.map((el)=>({key: el.key, text: el.name, value: el}));
                dispatch({type:'countries', payload: countriesOptions});
            }).catch((err)=>{
            console.log('err', err)
        });
        axios.get('/entity/all',).then(
            (res)=>{
                let entityOptions = res.data.map((el)=>({key: el.key, text: el.name, value: el}));
                dispatch({type:'entities', payload: entityOptions});
            }).catch((err)=>{
            console.log('err', err)
        });
        axios.get('/canton/all',).then(
            (res)=>{
                let cantonOptions = res.data.map((el)=>({key: el.key, text: el.name, value: el}));
                dispatch({type:'cantons', payload: cantonOptions});
            }).catch((err)=>{
            console.log('err', err)
        });
        axios.get('/municipality/all',).then(
            (res)=>{
                let municipalityOptions = res.data.map((el)=>({key: el.key, text: el.name, value: el}));
                dispatch({type:'municipalities', payload: municipalityOptions});
                // dispatch({type:'filteredMunicipalities', payload: municipalityOptions});

            }).catch((err)=>{
            console.log('err', err)
        });

        if(edit && student){
            dispatch({type:'country', payload: student.student.person.residence.place.country});
            if( !!student.student.person.residence.place.municipality && !!student.student.person.residence.place.municipality.entity ){
                dispatch({type:'entity', payload: student.student.person.residence.place.municipality.entity});
               // dispatch({type:'municipalities', payload:  student.student.person.residence.place.municipality.entity.key !== 'fbih' ? municipalities.filter((el)=>(el.value.entity && el.value.entity.key  === student.student.person.residence.place.municipality.entity.key)) : []});
            }
            if( !!student.student.person.residence.place.municipality && !!student.student.person.residence.place.municipality.canton){
                dispatch({type:'canton', payload: student.student.person.residence.place.municipality.canton});
               // dispatch({type:'municipalities', payload: municipalities.filter((el)=>(el.value.canton && el.value.canton.key  === student.student.person.residence.place.municipality.canton.key))});
                dispatch({type:'municipality', payload: student.student.person.residence.place.municipality});
            }
        }

        if(edit && teacher){
            dispatch({type:'country', payload: teacher.person.residence.place.country});
            if( !!teacher.person.residence.place.municipality && !!teacher.person.residence.place.municipality.entity ){
                dispatch({type:'entity', payload: teacher.person.residence.place.municipality.entity});
                // dispatch({type:'municipalities', payload:  student.student.person.residence.place.municipality.entity.key !== 'fbih' ? municipalities.filter((el)=>(el.value.entity && el.value.entity.key  === student.student.person.residence.place.municipality.entity.key)) : []});
            }
            if( !!teacher.person.residence.place.municipality && !!teacher.person.residence.place.municipality.canton){
                dispatch({type:'canton', payload: teacher.person.residence.place.municipality.canton});
                // dispatch({type:'municipalities', payload: municipalities.filter((el)=>(el.value.canton && el.value.canton.key  === student.student.person.residence.place.municipality.canton.key))});
                dispatch({type:'municipality', payload: teacher.person.residence.place.municipality});
            }
        }
    }, []);

    return (
        <div >
            <SegmentGroup raised>
                <Segment >
                    <Header as={'h4'}> {'Izmjena podataka'}
                        <span>
                           <Button floated={"right"} icon size={"mini"} basic onClick={toggleEditForm}>
                               <Icon name='close'/>
                           </Button>
                            {/*placeholder*/}
                            <Icon/>
                       </span>
                    </Header>
                </Segment>

                <Segment clearing>


                    <PlaceForm
                        oneRowTwoFields
                        handlePlaceChange={handlePlaceChange}
                        formName={'placeOfResidence'}
                        countries={state.countries}
                        entities={state.entities}
                        cantons={state.cantons}
                        municipalities={state.municipalities}
                        country = {state.country}
                        entity = {state.entity}
                        enableEntity = {state.enableEntity}
                        enableCanton = {state.enableCanton}
                        canton = {state.canton}
                        enableMunicipality = {state.enableMunicipality}
                        municipality = {state.municipality}
                        place = {state.place}
                        address = {state.address}
                        zip = {state.zip}

                        countryErr = {countryErr}
                        placeErr = {placeErr}
                        addressErr = {addressErr}
                        zipErr = {zipErr}
                    />

                    {/*<PlaceForm*/}
                    {/*    size={'small'}*/}
                    {/*    handleInputChange = {handleInputChange}*/}
                    {/*    countries = {state.countries}*/}
                    {/*    country = {state.country}*/}
                    {/*    enableEntity = {state.enableEntity}*/}
                    {/*    entities = {state.entities}*/}
                    {/*    entity = {state.entity}*/}
                    {/*    enableCanton = {state.enableCanton}*/}
                    {/*    canton = {state.canton}*/}
                    {/*    cantons = {state.cantons}*/}
                    {/*    enableMunicipality = {state.enableMunicipality}*/}
                    {/*    filteredMunicipalities = {state.filteredMunicipalities}*/}
                    {/*    municipality = {state.municipality}*/}
                    {/*    place = {state.place}*/}
                    {/*    address = {state.address}*/}
                    {/*    zip = {state.zip}*/}

                    {/*    countryErr = {countryErr}*/}
                    {/*    placeErr = {placeErr}*/}
                    {/*    addressErr = {addressErr}*/}
                    {/*    zipErr = {zipErr}*/}

                    {/*/>*/}

                    <Button floated={"right"} basic size={"small"} color={"teal"} onClick={student ? editStudent : editTeacher}>{ 'Sačuvaj'}</Button>
                </Segment>
            </SegmentGroup>
        </div>
    );
};

export default StudentPlaceOfResidenceForm;
